import { render, staticRenderFns } from "./dynamic-document-checkbox-field-template.vue?vue&type=template&id=4c1f1bd1&"
import script from "./dynamic-document-checkbox-field-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-checkbox-field-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
